import { render, staticRenderFns } from "./NewPartnershipModal.vue?vue&type=template&id=7486e9bd&"
import script from "./NewPartnershipModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnershipModal.vue?vue&type=script&lang=js&"
import style0 from "./NewPartnershipModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports